/*
 * バリデーション（名刺登録関連）
 */
import { composeValidators } from '@/utils/libs/react-final-form/validate';
import { isRequiredText, isFileValid, isAllowAcceptTypeFiles, isAllowMegaSizeFile, ACCEPT_IMAGE_MIME_TYPE, } from '@/utils/validate/conditions';
/**
 * validation: 名刺登録画像アップロード
 */
export const validateCardUpload = composeValidators(isRequiredText('ファイルを選択してください'), isFileValid(), isAllowAcceptTypeFiles(ACCEPT_IMAGE_MIME_TYPE, '画像ファイルを選択してください'), isAllowMegaSizeFile(10, '10MB以下のファイルを選択してください'));
